export const toggleBodyTheme = newTheme => {
  newTheme = newTheme || 'dark'
  const oldClass = newTheme === 'dark' ? 'light' : 'dark'

  document.body.classList.remove(oldClass)
  document.body.classList.add(newTheme)
}
